export default __webpack_public_path__ + "static/media/languagePantheon.8b18359c.png";